import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ChangePassword from '../pages/ChangePassword';

export default function ProtectedRoute({ roles, children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return <div className="os-page flex items-center justify-center"><div className="text-[var(--ttouch-muted)]">Loading…</div></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === 'cleaner' ? '/staff' : user.role === 'client' ? '/portal' : '/owner'} replace />;
  }
  if (user.must_change_password) {
    return <ChangePassword forced />;
  }
  return children;
}
